import { api, CACHE_TIME, getHeaders } from '@/api';
import { validateResponse } from '@/api/utils';
import { queryOptions } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

import { menuConfigApiResponseSchema, type MenuConfigResponse } from './schema';

export const mainMenuQueries = {
  all: ['mainMenu'] as const,
  config: () =>
    queryOptions({
      queryKey: mainMenuQueries.all,
      queryFn: async (): Promise<MenuConfigResponse | null> => {
        try {
          const response = await api.get('md/api/mainmenu', getHeaders());
          const parsed = validateResponse(menuConfigApiResponseSchema, response.data);
          return parsed.Data ?? null;
        } catch (error) {
          if (isAxiosError(error) && error.response?.status === 404) {
            return null;
          }
          throw error;
        }
      },
      staleTime: CACHE_TIME.STALE,
      gcTime: CACHE_TIME.GC
    })
};
